/**
 * User classroom APIs (trainee side only).
 * Used by pages/user/classroom. All under /org/classroom (userRoutes).
 */
import { GET, POST, UPLOAD_FILE } from "../apiController";

const ORG_CLASSROOM = "/user/classroom";

// ---------------------------------------------------------------------------
// 1. Classroom list & dashboard
// ---------------------------------------------------------------------------

export const getTraineeClassrooms = (data) => {
  return POST(`${ORG_CLASSROOM}/trainee/classrooms`, data);
};

export const getTraineeClassroomsDashboardData = (data) => {
  return POST(`${ORG_CLASSROOM}/dashboard`, data);
};

export const getTraineeClassroomCourses = (classroomId) => {
  return GET(`${ORG_CLASSROOM}/${classroomId}/courses`);
};

// ---------------------------------------------------------------------------
// 2. Assignments
// ---------------------------------------------------------------------------

export const getAssignments = (data) => {
  return POST(`${ORG_CLASSROOM}/user_assignments`, data);
};

export const getUserClassroomAssignmentById = (data) => {
  return POST(`${ORG_CLASSROOM}/user_assignment_details`, data);
};

export const getUserClassroomAssignmentsQuestions = (data) => {
  return POST(`${ORG_CLASSROOM}/get_user_classroom_assignments_questions`, data);
};

export const submitUserClassroomAssignmentResponse = (data) => {
  if (data instanceof FormData) {
    return UPLOAD_FILE(
      `${ORG_CLASSROOM}/submit_user_classroom_assignment_response`,
      data
    );
  }
  return POST(
    `${ORG_CLASSROOM}/submit_user_classroom_assignment_response`,
    data
  );
};

// ---------------------------------------------------------------------------
// 3. Assignment quiz
// ---------------------------------------------------------------------------

export const getClassroomAssignmentQuiz = (data) => {
  return POST(`${ORG_CLASSROOM}/get_assignment_quiz`, data);
};

export const submitClassroomAssignmentQuiz = (data) => {
  return POST(`${ORG_CLASSROOM}/submit_assignment_quiz`, data);
};

export const updateClassroomAssignmentVideoProgress = (data) => {
  return POST(`${ORG_CLASSROOM}/update_assignment_video_progress`, data);
};

// ---------------------------------------------------------------------------
// 4. Assessment (classroom)
// ---------------------------------------------------------------------------

export const getAllAssessmentToClassroomInUser = (data) => {
  return POST(`${ORG_CLASSROOM}/trainee_assessments`, data);
};

export const getUserClassroomAssessmentById = (data) => {
  return POST(`${ORG_CLASSROOM}/user_assessment_details`, data);
};

export const getAllQuestionsForClassroomAssessmentForUser = (data) => {
  return POST(`${ORG_CLASSROOM}/assessment/questions`, data);
};

export const submitClassroomAssessment = (data) => {
  return POST(`${ORG_CLASSROOM}/assessment/submit`, data);
};

export const saveIndividualQuestionAnswer = (data) => {
  return POST(`${ORG_CLASSROOM}/assessment/save-question-answer`, data);
};

export const startAdaptiveClassroomAssessment = (data) => {
  return POST(`${ORG_CLASSROOM}/assessment/adaptive/start`, data);
};

export const getAdaptiveClassroomNextQuestion = (attemptId) => {
  return GET(`${ORG_CLASSROOM}/assessment/adaptive/next-question/${attemptId}`);
};

export const submitAdaptiveClassroomAnswer = (data) => {
  return POST(`${ORG_CLASSROOM}/assessment/adaptive/submit-answer`, data);
};

export const finishAdaptiveClassroomAssessment = (data) => {
  return POST(`${ORG_CLASSROOM}/assessment/adaptive/finish`, data);
};

// ---------------------------------------------------------------------------
// 5. Resources (recorded)
// ---------------------------------------------------------------------------

export const getClassroomResourcesForTrainees = (data) => {
  return POST(`${ORG_CLASSROOM}/get_classroom_resources_for_trainees`, data);
};

export const getUserClassroomResourceById = (data) => {
  return POST(`${ORG_CLASSROOM}/user_resource_details`, data);
};

export const getAllResources = (data) => {
  return POST("/user/get_all_resources", data);
};

export const markResourceAsSeen = (data) => {
  return POST("/user/mark_resource_as_seen", data);
};

// ---------------------------------------------------------------------------
// 6. Live classes (Zoom)
// ---------------------------------------------------------------------------

export const getTraineeLiveClasses = (data) => {
  return POST(`${ORG_CLASSROOM}/zoom_live_classes`, data);
};

export const getUserClassroomLiveClassById = (data) => {
  return POST(`${ORG_CLASSROOM}/user_live_class_details`, data);
};

export const generateTraineeJoinToken = (data) => {
  return POST(`${ORG_CLASSROOM}/zoom_live_class/join_token`, data);
};
